import React from 'react';
import DocumentStorageList from '../components/documentStorage/DocumentStorageList';
import DocumentStorageTour from '../components/onboarding/DocumentStorageTour';

export default function DocumentStorage() {
  return (
    <>
      <DocumentStorageTour />
      <DocumentStorageList />
    </>
  );
}
